import colors from './colors';

// Configuración del tema para Ant Design
export const antdTheme = {
  token: {
    // Color primario (se usa en botones, links, etc.)
    colorPrimary: colors.primary.main,
    
    // Radio de borde por defecto
    borderRadius: 12,
    
    // Colores de estado
    colorSuccess: colors.status.success,
    colorError: colors.status.error,
    colorWarning: colors.status.warning,
    colorInfo: colors.status.info,
  },
};

// Exporta los colores para uso en styled-components y otros lugares
export { colors, getColor } from './colors';

// Exporta el tema completo
const theme = {
  colors,
  antdTheme,
};

export default theme;

